<template>
  <div class="product-list">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="公告名称">
          <el-input size="small" v-model="searchForm.search" placeholder="请输入公告名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="公告类型">
          <el-select v-model="searchForm.type" placeholder="请选择">
            <el-option label="技师" value="1"></el-option>
            <el-option label="暂无类型" value="0"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--添加产品-->
    <div class="common-level-rail" style="display:flex;">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加公告</el-button>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%">
          <!-- v-loading="loading" -->
          <el-table-column prop="title" align="center" label="公告名称">
          </el-table-column>
          <!-- <el-table-column prop="notice_type" label="公告类型">
            <template slot-scope="scope">
              <span v-if="scope.row.notice_type==1">技师</span>
              <span v-else>暂无类型</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="desc" align="center" label="公告内容"></el-table-column>
          <el-table-column prop="noticeSort" align="center" label="排序" ></el-table-column>
          <el-table-column prop="isShow" label="是否显示" align="center">
            <template slot-scope="scope">
              <el-switch class="switch" @change='isShow(scope.row)' v-model="scope.row.is_show" :active-value="1" :inactive-value="0" active-text="是" inactive-text="否">
              </el-switch>
            </template>
          </el-table-column>

          <el-table-column fixed="right" align="center" label="操作" width="240">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="primary" size="small">编辑公告</el-button>
              <el-button @click="delClick(scope.row)" type="danger" size="small">删除公告</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
import NoticeApi from "@/api/notice.js";
export default {
  components: {
    // Add
  },
  data() {
    return {
      tableData: [],
      open_add: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      searchForm: {
        search: ""
        // type: "1"
      },
      is_show: "" //公告是否显示
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    /*打开添加*/
    addClick() {
      this.$router.push("/technician/qita/notice/add");
    },
    // 是否显示公告
    isShow(row) {
      let self = this;
      NoticeApi.noticeshow({
        notice_id: row.notice_id,
        status: row.is_show
      }).then(data => {
        self.$message({
          message: "修改成功",
          type: "success"
        });
        self.getData();
      });
    },
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      NoticeApi.noticeList(Params, true)
        .then(data => {
          console.log(data,'公告列表数据')
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {
          // self.loading = false;
        });
    },
    /*打开编辑*/
    editClick(row) {
      console.log(row, "编辑技师");
      this.$router.push({
        path: "/technician/qita/notice/edit",
        query: {
          noticeId: row.noticeId,
          scene: "edit"
        }
      });
    },
    /*删除*/
    delClick: function(row) {
      let self = this;
      self
        .$confirm("确定删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          NoticeApi.noticedelete({
            notice_id: row.noticeId
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style scoped  lang='scss'>
.s_flex {
  display: flex;
  justify-content: space-between;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/qita/notice/index.vue